import styled from '@emotion/styled';
import Button from '@molecules/Button';
import Text from '@molecules/Text';
import { useTranslation } from 'react-i18next';
import ModalTermsAndConditions from '@view/components/Modals/TermsAndConditions';
import { useModal } from '@molecules/BEOffScreen';
import { Box } from '@chakra-ui/react';

const TermsAndConditions = ({ terms }: { terms: string }) => {
  const { t } = useTranslation();
  const modal = useModal(ModalTermsAndConditions, { width: 560 });

  return (
    <>
      <Text type="h2" mb="8px">
        {t('terms-and-conditions')}
      </Text>
      <Text type="body" html={terms} maxLines={10} />

      <Box>
        <StyledButton
          className="btn-show-more"
          color="primary"
          variant="outline"
          onClick={() => modal.open()}
        >
          {t('read-more-button')}
        </StyledButton>
      </Box>
    </>
  );
};

const StyledButton = styled(Button)`
  display: block;
`;

export default TermsAndConditions;
